import AboutUsImageAndText from 'components/about-us/AboutUsImageAndText';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import { DaymadeDesignSystemPreviewComponentInfo } from '../';

const ComponentPreview = () => {
  return (
    <>
      <AboutUsModule background={'grey'}>
        <AboutUsSiteContainer>
          <h2 className="aboutUsTypographyHeaderLarge">
            Image and Text module
          </h2>
          <p>
            A module that shows an image (or a video) next to some text. On
            mobile, the heading appears first, followed by the image and text
            content (the component's React children)
          </p>
        </AboutUsSiteContainer>
        <AboutUsImageAndText
          background="white"
          images={[
            {
              imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
              imageAlt: '',
            },
          ]}
          header={
            <h4 className="aboutUsTypographyHeaderMedium">Heading text</h4>
          }
        >
          <p>This is the text that appears alongside the images.</p>
        </AboutUsImageAndText>
        <AboutUsImageAndText
          background="tealGradient"
          images={[
            {
              imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
              imageAlt: '',
            },
          ]}
          header={
            <h4 className="aboutUsTypographyHeaderMedium">Heading text</h4>
          }
          imageOnRight
        >
          <p>The text can appear on the other side on desktop-sized screens</p>
        </AboutUsImageAndText>
        <AboutUsImageAndText
          background="grey"
          images={[
            {
              imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
              imageAlt: '',
            },
          ]}
          header={
            <h4 className="aboutUsTypographyHeaderMedium">Heading text</h4>
          }
          showImageFirstOnMobile
        >
          <p>
            The image can also be shown above the heading text on mobile devices
          </p>
        </AboutUsImageAndText>
      </AboutUsModule>
      <AboutUsImageAndText
        background="grey"
        images={[
          {
            imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
            imageAlt: '',
          },
          {
            imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
            imageAlt: '',
          },
        ]}
        header={<h4 className="aboutUsTypographyHeaderMedium">Heading text</h4>}
      >
        <p>This is what it looks like with two images.</p>
      </AboutUsImageAndText>
      <AboutUsImageAndText
        background="white"
        images={[
          {
            imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
            imageAlt: '',
          },
          {
            imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
            imageAlt: '',
          },
          {
            imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
            imageAlt: '',
          },
        ]}
        header={<h4 className="aboutUsTypographyHeaderMedium">Heading text</h4>}
      >
        <p>This is what it looks like with three images.</p>
      </AboutUsImageAndText>
      <AboutUsImageAndText
        background="grey"
        images={[
          {
            imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
            imageAlt: '',
          },
          {
            imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
            imageAlt: '',
          },
          {
            imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
            imageAlt: '',
          },
          {
            imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
            imageAlt: '',
          },
        ]}
        header={<h4 className="aboutUsTypographyHeaderMedium">Heading text</h4>}
      >
        <p>This is what it looks like with four images.</p>
      </AboutUsImageAndText>
      <AboutUsImageAndText
        background="white"
        videoSrc="https://daymade-website-assets.s3.amazonaws.com/2026/homepage/how-it-works.mp4"
        header={<h4 className="aboutUsTypographyHeaderMedium">Heading text</h4>}
      >
        <p>
          A video can also be used. The video will be 16:9 on mobile-sized
          screens, and clipped to a portrait-rectangle on desktop sized screens
        </p>
      </AboutUsImageAndText>
      <AboutUsImageAndText
        background="white"
        videoSrc="https://daymade-website-assets.s3.amazonaws.com/2026/homepage/how-it-works.mp4"
        header={<h4 className="aboutUsTypographyHeaderMedium">Heading text</h4>}
      >
        <p>
          A video can also be used. The video will be 16:9 on mobile-sized
          screens, and clipped to a portrait-rectangle on desktop sized screens
        </p>
      </AboutUsImageAndText>
      <AboutUsImageAndText
        background="grey"
        images={[
          {
            imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
            imageAlt: '',
          },
        ]}
      >
        <p>This example has no header</p>
      </AboutUsImageAndText>
      <AboutUsImageAndText
        background="tealGradient"
        images={[
          {
            imagePath: `https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2025/how-it-works/desktop/Platinum.jpg`,
            imageAlt: '',
          },
        ]}
        header={<p>This example has a header, but no children</p>}
      >
        {null}
      </AboutUsImageAndText>
    </>
  );
};

ComponentPreview.daymadeDesignSystemInfo = {
  name: 'Image and Text',
} as DaymadeDesignSystemPreviewComponentInfo;

export default ComponentPreview;
